import { render, staticRenderFns } from "./personnel-add.vue?vue&type=template&id=4fa057e6&scoped=true&"
import script from "./personnel-add.vue?vue&type=script&lang=js&"
export * from "./personnel-add.vue?vue&type=script&lang=js&"
import style0 from "./personnel-add.vue?vue&type=style&index=0&id=4fa057e6&scoped=true&lang=css&"
import style1 from "./personnel-add.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa057e6",
  null
  
)

export default component.exports